import {
  BehaviorSubject,
} from 'rxjs';
import {
  distinctUntilChanged,
  scan,
  shareReplay,
  skipWhile,
} from 'rxjs/operators';

const MediaNodeStore = () => {
  const $ = new BehaviorSubject()
    .pipe(
      scan((state, action = {}) => {
        switch (action.__id) {
          case 'PUSH_MEDIA_NODE':
            return action.node;
          default:
            return state;
        }
      }, undefined),
      skipWhile((val) => !val),
      distinctUntilChanged(),
      shareReplay(1),

    );
  return {
    $,
    destroy: () => {
      $.complete();
    },
    actions: {
      pushMediaNode: (node) => (
        $.next({
          __id: 'PUSH_MEDIA_NODE',
          node,
        })
      ),
    },
  };
};

export default MediaNodeStore;
